<div class="col full-height layout-column">

  <app-planning-draft-resources-panel-list-item [resource]="resource"
                                                [settings]="settings"
                                                [resourceRoutes]="sortedRoutes ?? []"
                                                [itemElementSize]="itemElementSize"
                                                [isSelected]="false"
                                                [canClose]="true"
                                                (onEditResourceAllocation)="onEditResourceAllocation.emit($event)"
                                                (onDispatch)="onDispatch.emit($event)"
                                                (onClose)="onClose.emit()">
  </app-planning-draft-resources-panel-list-item>

  <div class="flex layout-column overflow-auto ">
<!--    <div *ngIf="!!routes && !routes.length" class="layout-row layout-align-center-center padding-20">-->
<!--      <span class="br-body-1">{{ 'No routes connected' | translate }}</span>-->
<!--    </div>-->

    <!--Loading Mode-->
    <div *ngIf="!sortedRoutes"
         class="flex-100 layout-row layout-align-center-center">
      <div class="spinner-border" role="status">
        <span class="sr-only"></span>
      </div>
    </div>

    <div class="flex layout-column dndList overflow-auto margin-top-5"
         [id]="panel.id"
         cdkDropList
         (cdkDropListEntered)="onEnterEmpty()"
         (cdkDropListExited)="onExitEmpty()"
         [cdkDropListData]="sortedRoutes"
         [cdkDropListConnectedTo]="connectedPanelIds"
         (cdkDropListDropped)="drop($event)">

      <app-planning-draft-routes-panel-list-item *ngFor="let route of sortedRoutes; trackBy: trackByRouteId"
                                                 cdkDrag
                                                 [cdkDragData]="route"
                                                 [route]="route"
                                                 [logisticsVehicleName]="resource.mainLogisticsVehicleReference?.name"
                                                 [jobs]="jobs"
                                                 [draft]="draft"
                                                 [settings]="routesSettings"
                                                 [isVisible]="visibleKeys[route.id]"
                                                 [isShowActionMenu]="true"
                                                 [canDrilldown]="true"
                                                 (onDrillDown)="onOpenRoute.emit($event)"
                                                 (onEditResourceAllocation)="onEditResourceAllocation.emit($event)"
                                                 (onChangeRouteResource)="onChangeRouteResource.emit($event)"
                                                 (onLockRouteChange)="onLockRouteChange.emit($event)"
                                                 (onDispatch)="onDispatchRoutes.emit([$event])"
                                                 (onReoptimize)="onReoptimize.emit($event)"
                                                 (onPrint)="onPrint.emit($event)"
                                                 (onPrintLoadingSheet)="onPrintLoadingSheet.emit($event)"
                                                 (onDelete)="onDelete.emit($event)"
                                                 (onToggleVisible)="onToggleVisibleRoute(route.id, $event)">
      </app-planning-draft-routes-panel-list-item>

      <div *ngIf="!sortedRoutes?.length"
           class="flex-100 layout-column">
        <app-empty-state *ngIf="!hovered" src="assets/images/empty_state/empty_state_routes.png"
                         text="No Routes Found">
        </app-empty-state>
        <div *ngIf="hovered" class="flex-100 full-height layout-row layout-align-center-center">
          <h1 class="br-head-2 font-weight-600">{{ 'Add To Resource' | translate }}</h1>
        </div>
      </div>


    </div>






<!--    <app-planning-draft-routes-panel-list-item *ngFor="let route of sortedRoutes; trackBy: trackByRouteId"-->
<!--                                               class="margin-left-10"-->
<!--                                               [route]="route"-->
<!--                                               [draft]="draft"-->
<!--                                               [settings]="routesSettings"-->
<!--                                               [isVisible]="visibleKeys[route.id]"-->
<!--                                               [isShowActionMenu]="true"-->
<!--                                               [canDrilldown]="true"-->
<!--                                               (onDrillDown)="onOpenRoute.emit($event)"-->
<!--                                               (onEditResourceAllocation)="onEditResourceAllocation.emit($event)"-->
<!--                                               (onChangeRouteResource)="onChangeRouteResource.emit($event)"-->
<!--                                               (onLockRouteChange)="onLockRouteChange.emit($event)"-->
<!--                                               (onDispatch)="onDispatch.emit($event)"-->
<!--                                               (onReoptimize)="onReoptimize.emit($event)"-->
<!--                                               (onPrint)="onPrint.emit($event)"-->
<!--                                               (onPrintLoadingSheet)="onPrintLoadingSheet.emit($event)"-->
<!--                                               (onDelete)="onDelete.emit($event)"-->
<!--                                               (onToggleVisible)="onToggleVisibleRoute(route.id, $event)">-->
<!--    </app-planning-draft-routes-panel-list-item>-->
  </div>

</div>

